var AlertAPI = require('../api').Alert;


module.exports = function($scope, $rootScope){
  var vm = this;
  vm.pageNumber = 1;
  vm.pageSize = 10;
  vm.numberOfPages = 0;
  vm.totalResults = 0;

  vm.init = function(pageNumber){
    vm.loading = true;
    var query = {
      pageNumber: pageNumber,
      pageSize: vm.pageSize,
      includeUnread: true,
      includeDismissed: true,
      filter: vm.filter,
    }
    return AlertAPI.Get(query).then(function(result){
      vm.alerts = result.results;
      vm.numberOfPages = Math.ceil(result.totalResults / vm.pageSize)
      vm.totalResults  = result.totalResults;
      vm.loading = false;

      vm.alerts.forEach(function(a, i){
        if (a.sourceRef == "UpdateApplicationSingleStepCommandHandler" || a.sourceRef == "SetEditModeCommandHandler") {
          a.link = '/funder/dashboard/shortlist/' + a.targetId;
          return;
        }

        if (a.sourceRef == "ApplicationApproved" || a.sourceRef == "FundingOfferedSendApplicantAlertEventHandler" || a.sourceRef == "AdditionalQuestionsReceived") {
          a.link = '/applicant/dashboard/projects/' + a.targetId;
          return;
        }

        if (a.sourceRef == "FundingRejected" || a.sourceRef == "FundingAccepted") {
          a.link = '/funder/dashboard/applications/' + a.targetId;
          return;
        }

        if (a.sourceRef == "AddFunderPaymentTermAlertEventHandler") {
          a.link = '/funder/dashboard/payments';
          return;
        }

        if (a.sourceRef == "DirectApplicationReceived") {
          a.link = '/funder/dashboard/applications/' + a.targetId;
          return;
        }

        if (a.sourceRef == "CreateRaisedFundsCommandHandler" || a.sourceRef == "UpdateRaisedFundsCommandHandler" || a.sourceRef == "DeleteRaisedFundsCommandHandler") {
          a.link = '/funder/dashboard/shortlist/' + a.targetId;
          return;
        }

        if (a.sourceRef == "ResetToDraftCommandHandler") {
          a.link = '/funder/dashboard/shortlist/' + a.targetId;
          return;
        }

        if (a.sourceRef == "ApplicationExtendedEventHandler" || a.sourceRef == "SubmitApplicationFundingCommandHandler" || a.sourceRef == "WithdrawFundingOfferCommandHandler" || a.sourceRef == "AdditionalQuestionsReceived") {
          a.link = '/applicant/dashboard/projects/' + a.targetId;
          return;
        }

        if (a.targetType == "funderApplicationRequestEditChanged") {
          a.link = '/funder/dashboard/applications/' + a.targetId;
          return;
        }

        if (a.sourceRef == "FundingAcceptedEventHandler") {
          a.link = "/funder/dashboard/shortlist/" + a.targetId;
          return;
        }
      })
    })
  }

  vm.onClick = function($event, a) {
    $event.stopPropagation();
    $event.preventDefault();
    if (a.dismissed) {
      if (!a.link) return;
      window.location = a.link;
      return;
    }

    vm.markAsRead(a).then(function(){
      if (a.link) {
        window.location = a.link;
        return;
      }
    })
  }

  vm.onMarkAsReadClick = function($event, a) {
    $event.stopPropagation();
    $event.preventDefault();
    vm.markAsRead(a)
  }

  vm.markAsRead = function(a){
    return AlertAPI.MarkAsRead(a.id).then(function(){
      a.dismissed = true;
    }).catch(function(){
      vm.pageNumber = 1;
      vm.init(vm.pageNumber);
    }).finally(function(){
      $rootScope.reloadNotificationCount();
    })
  }

  vm.pageChange = function(to){
    vm.init(to).then(function(){
      vm.pageNumber = to;
      window.scrollTo(0, 0);
    })
  }



  vm.init(vm.pageNumber);
}
